import { api } from "./client";

export interface Usage {
  /** ISO start of the current billing month. */
  periodStart: string;
  /** Steps executed so far this month across the account. */
  stepsUsed: number;
  /** Monthly step allowance for the plan; null = unlimited (OSS/self-host). */
  stepsIncluded: number | null;
  /** "ok" while under quota, "over" once the allowance is exhausted. */
  status: "ok" | "over";

  // Metered resources (used vs. plan limit). A null limit = unlimited.
  environmentsUsed?: number;
  environmentsLimit?: number | null;
  functionsUsed?: number;
  functionsLimit?: number | null;

  // Plan caps shown as info (not consumable). null = unlimited.
  concurrency?: number | null;
  retentionDays?: number | null;
  payloadBytes?: number | null;
  ingestPerMinute?: number | null;
}

export const usageApi = {
  get: () => api<Usage>("/api/dashboard/usage"),
};
